// src/pages/clab-selection-requests/components/ApproveModal.jsx
import React from 'react';
import Icon from '../../../components/AppIcon';

/**
 * Reusable approve modal component
 * @param {Object} props - Component props
 * @param {boolean} props.show - Whether to show the modal
 * @param {Object} props.application - Selected application
 * @param {boolean} props.processing - Whether approval is in progress
 * @param {Function} props.onConfirm - Confirm approval callback
 * @param {Function} props.onCancel - Cancel approval callback
 */
const ApproveModal = ({ 
  show, 
  application, 
  processing, 
  onConfirm, 
  onCancel 
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
        <div className="mt-3">
          <div className="flex items-center justify-center w-12 h-12 mx-auto bg-green-100 rounded-full">
            <Icon name="CheckCircle" className="h-6 w-6 text-green-600" />
          </div>
          
          <div className="mt-4 text-center">
            <h3 className="text-lg font-medium text-gray-900">
              Approve Application
            </h3>
            <p className="text-sm text-gray-500 mt-2">
              Are you sure you want to approve this application?
            </p>
            
            {application && (
              <div className="mt-3 p-3 bg-gray-50 rounded-md">
                <p className="text-sm font-medium text-gray-900">
                  {application.employer?.company_name}
                </p>
                <p className="text-sm text-gray-600">
                  Application ID: {application.id}
                </p>
              </div>
            )}
          </div>
          
          <div className="flex justify-center space-x-3 mt-6">
            <button
              onClick={onCancel}
              disabled={processing}
              className="px-4 py-2 bg-white border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              disabled={processing}
              className="px-4 py-2 bg-green-600 border border-transparent rounded-md text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center"
            >
              {processing && (
                <Icon name="Loader2" className="h-4 w-4 mr-2 animate-spin" />
              )}
              {processing ? "Approving..." : "Approve"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApproveModal;